import React, { useCallback, useEffect, useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { REACT_APP_GOOGLE_MAPS_API_KEY } from "../../config/app-config";
import * as configuration from "../../config/app-config.js";
import { Icon } from "@iconify/react/dist/iconify.js";

const containerStyle = {
  width: "100%",
  height: "100%",
};

function MapComponent({ userLocation, doctors }) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: REACT_APP_GOOGLE_MAPS_API_KEY, // Use your actual API key here
  });

  const [map, setMap] = useState(null);
  const [selectedDoctor, setSelectedDoctor] = useState(null); // For InfoWindow

  const defaultCenter = {
    lat: 13.307229, // Default center: Chennai, India
    lng:  80.146590
  };

  console.log("Map defaultCenter ",   defaultCenter.latitude);
  console.log("Map length ",  userLocation);

  // Callback for when the map is loaded
  const onLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  // Callback for when the map is unmounted
  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const handleMarkerClick = (doctor) => {
    setSelectedDoctor(doctor);
  };

  console.log("userLocation", userLocation);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={
        typeof userLocation === "object" &&
        userLocation !== null &&
        Object.keys(userLocation).length === 2 &&
        typeof userLocation.latitude === "number" &&
        typeof userLocation.longitude === "number"
          ? { lat: userLocation.latitude, lng: userLocation.longitude }
          : '' // Default center when validation fails
      }
      // center ={{ lat: userLocation.latitude, lng: userLocation.longitude }}
      zoom={10}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {/* Render markers dynamically from doctorsList */}
      {doctors.map((doctor, index) => (
        <Marker
          key={index}
          position={{ lat: doctor.latitude, lng: doctor.longitude }}
          title={doctor.displayName}
          // icon={{
          //   url: doctor.image
          //     ? `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
          //         <svg xmlns="http://www.w3.org/2000/svg" width="48" height="72" viewBox="0 0 48 72">
          //           <path d="M24 0C11 0 0 11 0 24c0 13.3 24 48 24 48s24-34.7 24-48C48 11 37 0 24 0z" fill="#ff4d4f"/>
          //           <circle cx="24" cy="24" r="14" fill="#fff"/>
          //           <image href="${configuration.API_URL}auth/assets/${doctor.image}" x="10" y="10" height="28" width="28" clip-path="circle(14)"/>
          //         </svg>
          //       `)}`
          //     : null,
          //   scaledSize: new window.google.maps.Size(40, 40), // Adjust marker size
          // }}
          onClick={() => handleMarkerClick(doctor)}
        />
      ))}

      {/* InfoWindow for selected marker */}
      {selectedDoctor && (
        <InfoWindow
          position={{
            lat: selectedDoctor.latitude,
            lng: selectedDoctor.longitude,
          }}
          onCloseClick={() => setSelectedDoctor(null)}
        >
          <div style={{ textAlign: "center" }}>
            <img
              src={`${configuration.API_URL}auth/assets/${selectedDoctor.image}`}
              // src={`/path/to/images/${selectedDoctor.image}`}
              alt={selectedDoctor.displayName}
              style={{ width: "50px", borderRadius: "50%" }}
            />
            <h3>{selectedDoctor.displayName}</h3>
            <p>{selectedDoctor.specialityName}</p>
            <p>{selectedDoctor.bio}</p>
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${selectedDoctor.latitude},${selectedDoctor.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="google-btn"
            >
              <Icon
                icon="ri:direction-fill"
                width="20"
                height="20"
                style={{ color: "#1a73e8" }}
              />{" "}
              Directions
            </a>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  ) : (
    <div>Loading...</div>
  );
}

export default React.memo(MapComponent);
